import { render } from "./popularTab.vue?vue&type=template&id=44fbaa1b&scoped=true"
import script from "./popularTab.vue?vue&type=script&lang=js"
export * from "./popularTab.vue?vue&type=script&lang=js"

import "./popularTab.vue?vue&type=style&index=0&id=44fbaa1b&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44fbaa1b"]])

export default __exports__